<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

import DikeProfileDrawer from '@/components/dikeProfile/DikeProfileDrawer.vue'
import OverviewDrawer from '@/components/overview/OverviewDrawer.vue'
import DikeTrajectoryDrawer from '@/components/dike/DikeTrajectoryDrawer.vue'

const store = useStore()
const route = useRoute()

const schematisationDrawer = computed(() => store.state.project.schematisationDrawer)
const showComments = computed(() => store.state.comment.show)
const expand = computed(() => store.state.dikeProfiles.expand)

const selectedProjectId = computed(() => store.getters['project/selectedProjectId'])
const allDrawerWidth = computed(() => store.getters['project/getAllDrawerWidth'])

const showDrawer = computed(() => {
  return (
    route.name === 'dikeIndex-trajectory' ||
    ((route.name === 'schematisation' || route.name === 'schematisation-stage') &&
      schematisationDrawer.value)
  )
})

const toggleExpand = (value) => store.dispatch('dikeProfiles/toggleExpand', value)

const drawerWidth = computed(() => {
  return expand.value || showComments.value ? `calc(100vw - ${allDrawerWidth.value})` : '35vw'
})
</script>
<template>
  <template v-if="showDrawer">
    <DikeTrajectoryDrawer />
    <DikeProfileDrawer :drawer-width="drawerWidth" :expand="expand" @toggle-expand="toggleExpand" />
    <OverviewDrawer
      v-if="selectedProjectId"
      :drawer-width="drawerWidth"
      :expand="expand"
      @toggle-expand="toggleExpand"
    />
  </template>
</template>
